import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';

import AvailabilityLoader from 'organisms/Loaders/AvailabilityLoader';
import {
  addDayAvailabilityPlaceholder,
  editSingleAvailabilityPlaceholder,
  removeRange,
  setDayAvailability,
} from 'store/reducers/singleAvailability';
import { setUnavailability } from 'store/reducers/singleUnavailability';

import { convertToRecurringData, filterOutExistingSlots } from '../../util';
import OverrideSection from '../Overrides/OverrideSection';
import AvailabilityRangeList from './AvailabilityRangeList';

export default function SingleDaySection() {
  const dispatch = useDispatch();
  const { drawer, selectedGroomer } = useSelector((state) => state.ui);
  const {
    single: singleInventory,
    recurring: recurringInventory,
    unavailable: unavailableInventory,
    groomerUuid,
  } = useSelector((state) => state.inventory);
  const { availability } = useSelector((state) => state.singleAvailability);
  const { recurring } = useSelector((state) => state.singleRecurring);
  const providerLocations = useSelector((state) => state.provider.locations);
  const providerIncrement = providerLocations[0]?.minApptLengthSecs;
  const { date } = drawer.data;

  useEffect(() => {
    // Wait for selected groomer's data to finish loading
    if (drawer.data && groomerUuid === selectedGroomer.uuid) {
      const selectedSlots = convertToRecurringData({
        data: drawer.data,
        increment: providerIncrement,
      });

      const selectedSlotsData = selectedSlots.map((el) => ({
        ...el,
        start: el.start.replace('.000Z', ''),
        end: el.end.replace('.000Z', ''),
        isPlaceholder: true,
      }));

      const todaysRecurring = recurringInventory.filter(
        (el) => el.eventDate === date
      );
      const todaysSingle = singleInventory.filter(
        (el) => el.eventDate === date
      );

      const filteredSelectedSlots = filterOutExistingSlots(
        selectedSlotsData,
        todaysRecurring,
        todaysSingle
      );

      const singleData = {
        data: {
          availability: [...todaysSingle, ...filteredSelectedSlots],
          date,
        },
      };
      const todaysUnavailable = unavailableInventory.filter(
        (el) => el.date === date
      );
      const unavailableData = {
        unavailable: todaysUnavailable,
        isEditingUnavailability: false,
        date,
      };

      dispatch(setDayAvailability(singleData));
      dispatch(setUnavailability(unavailableData));
    }
  }, [groomerUuid, date]);

  /* Single actions */

  const addSingle = () => {
    dispatch(addDayAvailabilityPlaceholder());
  };

  const removeSingle = ({ uuid, isPlaceholder }) =>
    removeRange({
      uuid,
      isPlaceholder,
    });

  const editSingle = ({ day, obj, range }) =>
    editSingleAvailabilityPlaceholder({ day, obj, range });

  return (
    <div className="w-100 flex-column justify-between">
      <div className="recurrent-availability">
        <div className="flex-column recurrent-availability-container">
          {!availability ? (
            <AvailabilityLoader />
          ) : (
            <>
              <AvailabilityRangeList
                dayData={availability}
                date={date}
                title="Today only"
                addRange={addSingle}
                editRange={editSingle}
                removeRange={removeSingle}
              />
              <OverrideSection inSingleDayPanel />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
